/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Overage_OnInputs */



/**
* | output |
* | --- |
* | "Pay-per-use after the budget is ON: once the prepaid budget is used up, usage continues and is metered like the Team plan. It is not invoiced automatically —..." |
*
* @param {Partner_Org_Contract_Overage_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_overage_on = /** @type {((inputs?: Partner_Org_Contract_Overage_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Overage_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsbasierte Abrechnung nach dem Budget ist AN: Ist das vorausbezahlte Budget verbraucht, läuft die Nutzung weiter und wird wie im Team-Tarif gemessen. Sie wird nicht automatisch berechnet — sie erscheint im monatlichen Prüfbericht und wird separat abgerechnet.")
	return /** @type {LocalizedString} */ ("Pay-per-use after the budget is ON: once the prepaid budget is used up, usage continues and is metered like the Team plan. It is not invoiced automatically — it appears on the monthly review report to be charged separately.")
});